import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/setting'

import 'lib-flexible/flexible'

// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// Vue.use(ElementUI)

import 'element-ui/lib/theme-chalk/index.css'
import './plugins/element/index.js'
import $ from 'jquery'
window.$ = window.jQuery = $

// 检测package.json版号(version)不一样则清除缓存
// const VUE_APP_VERSION = require('../package.json').version
// const vers = window.localStorage.getItem('Version')
// if (VUE_APP_VERSION !== vers) {
//   window.localStorage.removeItem('power-up')
//   window.localStorage.setItem('Version', VUE_APP_VERSION)
//   location.reload()
// }

Vue.config.devtools = true

import '@/styles/index.scss' // global css

import Dialog from 'comp/content/Dialog/Dialog.vue'
Vue.component('Dialog', Dialog)

import * as keys from '@/utils/filters.js'
Object.keys(keys).filter(item => {
  Vue.filter(item, keys[item])
})

/* postcss-pxtorem 行内样式无法转换 */
const px2rem = px => /%/ig.test(px) ? px : `${parseFloat(px) / 192}rem`
Vue.prototype.$px2rem = px2rem

import VueTouch from 'vue-touch'
Vue.use(VueTouch, { name: 'v-touch' })

// import videoJs from 'video.js'
// import 'video.js/dist/video-js.css'
// import 'videojs-flash'
// import 'vue-video-player/src/custom-theme.css'
// import 'videojs-flvjs'
// window.videojs = videoJs
// require('../node_modules/video.js/dist/lang/zh-CN.js')

import hls from 'videojs-contrib-hls'
Vue.use(hls)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
